module.exports = __webpack_public_path__ + "mt.svg?7893921d36e78a4d12001a42115e20a6";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mt.svg
// module id = 1135
// module chunks = 27